<template>
    <div >
        <ErrorAlert :message="message" :error="error" />
        <StageComplete v-if="stageComplete" :message="message" :error="error" />

        <div v-else>
            <div class="card card-body border-0">
                <h6 class="font-weight-bold mb-4">Biller Profile</h6>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label>Biller Logo</label>
                            <FileUpload fileType="image" :aspect-ratio="16/9" v-model="profileForm.logo" :key="'logo-upload'"/>
                            <div v-text="profileForm.errors.get('logo')" class="text-danger font-12"/>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label>Featured Image <small>*Optional</small></label>
                            <FileUpload fileType="image" :aspect-ratio="1" v-model="profileForm.display_image" :cropped-image-height="300" :key="'display-upload'"/>
                            <div v-text="profileForm.errors.get('display_image')" class="text-danger font-12"/>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label>Biller Name</label>
                            <input type="text" v-model="profileForm.biller_name" class="form-control" placeholder="Enter your biller name">
                            <div v-text="profileForm.errors.get('biller_name')" class="text-danger font-12"/>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label>Description</label>
                            <textarea v-model="profileForm.description" class="form-control" placeholder="Enter a brief description"></textarea>
                            <div v-text="profileForm.errors.get('description')" class="text-danger font-12"/>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label>Category</label>
                            <select v-model="profileForm.category" class="form-control">
                                <option selected value="" disabled>-- Select Category --</option>
                                <option v-for="c in categories" :key="c" :value="c">{{ c }}</option>
                            </select>
                            <div v-text="profileForm.errors.get('category')" class="text-danger font-12"/>
                        </div>
                    </div>
                </div>
            </div>
            <button
                class="btn btn-primary btn-block my-4"
                :class="{ 'btn-loading': loading }"
                @click="submitCorporateDetails"
            >
                Next
            </button>
        </div>

    </div>
</template>

<script>
import Form from "../../../../../core/forms/form";
import FileUpload from "../../../components/FileUpload.vue";
import StageComplete from "../../../components/StageComplete.vue";
import ErrorAlert from "../../../components/ErrorAlert.vue";

export default {
    name: "Biller",
    components: {ErrorAlert, FileUpload, StageComplete },
    props:['stage'],
    data() {
        return {
            stage: 1,
            categories: ["Donations", "Subscriptions", "Invoices", "Utilities", "Fees", "Tickets", "Rentals", "Installments", "Vouchers", "Insurance", "Taxes"],
            profileForm: new Form({
                biller_name: "",
                description: "",
                category: "",
                logo: '',
                display_image: '',
                status: 'PROFILE-CREATED'
            }),
            message: "",
            error: false,
            loading: false,
            stageComplete: false,
        };
    },
    methods: {
        async submitCorporateDetails() {
            this.loading = true;
            this.error = false;
            this.message = "";
            this.profileForm
                .upload(`/business/biller-onboarding/profile`)
                .then((response) => {
                    this.stageComplete = true;
                    this.message = response.data.message;
                    if(this.stageComplete === true) {
                        setTimeout(function () {
                            this.stageComplete = false;
                            this.$emit("update-stage", this.stage + 1);
                            this.message = "";
                        }.bind(this), 3000);
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.response?.data?.message || "Failed to save corporate details.";
                    this.loading = false;
                });
        },
    },
};

</script>
<style scoped>

</style>
